import { css, keyframes } from '@emotion/css';
import { theme, setDefault } from '../../styles/theme';
import { deepDefaults } from '../../styles/utils';
import '../../styles/global';
import { cache } from '../utils';
var defaults = {
  inset: '-3px'
};
var wave;
setDefault(function () {
  wave = deepDefaults(theme, {
    wave: defaults
  }).wave;
  makeStyles == null || makeStyles.clearCache();
});
export var makeStyles = cache(function makeStyles(color, inset, k) {
  var waveEffect = /*#__PURE__*/keyframes("100%{top:calc(", inset, " + ", wave.inset, ");bottom:calc(", inset, " + ", wave.inset, ");left:calc(", inset, " + ", wave.inset, ");right:calc(", inset, " + ", wave.inset, ");opacity:0.05;}");
  return /*#__PURE__*/css("position:relative;&::after{display:block;content:'';position:absolute;top:", inset, ";bottom:", inset, ";left:", inset, ";right:", inset, ";opacity:0.4;border-radius:4px;z-index:2;animation:", waveEffect, " .2s ease-in;animation-fill-mode:forwards;border:2px solid ", color, ";pointer-events:none;}&.", k, "-circle,&.", k, "-radio-wrapper{&:after{border-radius:calc(", theme.large.height, " / 2 + 4px);}}");
});